import React from 'react';

const CollaboratorTextIntro = () => {
  return (
    <p className="text-gray">
      Below are the terms that your collaborator is proposing. Before this
      agreement can be finalized, you will need to give them your feedback.
      Start with the first tab of questions and click "continue" to move to the
      next. For each term, you can accept the terms or suggest alternatives
      (don’t worry, this isn’t binding yet). To view how your choices change the
      actual language of the agreement, scroll down and click on "View Testing
      Draft".
    </p>
  );
};

export default CollaboratorTextIntro;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/CollaboratorTextIntro.js